import { render, staticRenderFns } from "./AppTabCreator.vue?vue&type=template&id=9764318e&"
import script from "./AppTabCreator.vue?vue&type=script&lang=ts&"
export * from "./AppTabCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports